import React from "react";
import {Box} from "@mui/material";
import PerformanceMetrics from "../Utilities/PerformanceMetrics";
import CampaignsTable from "../Utilities/CampaignsTable";
import useGetAcquireCampaigns from "../Utilities/hooks/useGetAcquireCampaigns";
import {MetricsDetailFooter as Footer} from "../../MetricsDetail/Sections";
import useLocationQueryDateRange from "../../../hooks/useLocationQueryDateRange";
import moment from "moment";

export default function CompanyAcquireDashboard() {
    const yearCount = 2
    const { startDate, endDate, setDates } = useLocationQueryDateRange(
        { initialStartDate: moment().subtract(yearCount, 'years') }
    );
    const dateParams = {
        startDate: moment(startDate).startOf('day').toISOString(),
        endDate: moment(endDate).endOf('day').toISOString(),
    }
    const {rows, columns, totalCount, loading, changePage, page} = useGetAcquireCampaigns(dateParams)

    const handlePageChange = (event, nextPage) => {
        changePage(nextPage)
    };

    const handleTableCellClick = (params) => {
        window.location.replace(params);
    }

    return(
        <Box sx={{backgroundColor: '#EDEDE4'}}>
            <Box sx={styles.root}>
                <Box sx={styles.container}>
                    <Box>
                        <Box component={'h1'} sx={styles.headingLarge}>
                            Acquire
                        </Box>
                        <PerformanceMetrics
                            dateParams={dateParams} 
                            startDate={startDate} 
                            endDate={endDate} 
                            setDates={setDates}
                            yearCount={yearCount}
                        />
                    </Box>

                    <Box mt={{ xs: '30px', sm: '42px', }}>
                        <Box component={'h2'} sx={styles.headingSmall}>
                            All Campaigns
                        </Box>
                        <CampaignsTable
                            rows={rows}
                            columns={columns}
                            totalCount={totalCount}
                            loading={loading}
                            page={page}
                            handlePageChange={handlePageChange}
                            handleTableCellClick={handleTableCellClick}
                        />
                    </Box>
                </Box>
            </Box>

            <Footer />
        </Box>
    )
}

const styles = {
    root: {
        fontFamily: 'FustatMedium',
        letterSpacing: '-0.02em',
        color: '#302E2A',
        pt: 13,
        minHeight: '100vh',
    },
    container: {
        px: { xs: 2, sm: 6 },
        maxWidth: '1440px',
        position: 'relative',
        mx: 'auto',
    },
    headingLarge: {
        mb: 0,
        fontFamily: 'IvyPrestoHeadlineRegular',
        fontSize: '35px',
        lineHeight: 1.2,
        letterSpacing: '0.03em'
    },
    headingSmall: {
        fontFamily: 'FustatBold',
        fontSize: '17px',
        letterSpacing: '0.01em'
    }
}